import Modal from "react-responsive-modal";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import CustomButton from "components/CustomButton";

const AIMethods = ({ handleModal, handleType }) => {
  return (
    <Modal
      open
      onClose={handleModal}
      showCloseIcon={false}
      classNames={{
        modalContainer: "modalContainer",
        modal: "queryModalContainer",
      }}
    >
      <div className="confirmationModalContent">
        <div className="chatGptQueryHeader">
          <h5 className="text-center confirmationModalHeader">
            How you want to proceed
          </h5>
          <span className="chatgptCloseModal">
            <CancelIcon className="closeIcon" onClick={handleModal} />
          </span>
        </div>
        <hr />
        <div className="p-3">
          <div className="align-items-center d-flex justify-content-center flex-column gap-2">
            <h5>
              Please select the option to provide the description to generate
              Summary.
            </h5>
            <div className="d-flex gap-3 w-100">
              <CustomButton onClick={() => handleType(1)}>Text</CustomButton>
              <CustomButton onClick={() => handleType(2)}>Media</CustomButton>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AIMethods;
